export default __webpack_public_path__ + "static/media/stockpile-sidebar-icon.51d5880d.svg";